import React from "react";

function App() {
  const programDownloadLink = "https://drive.google.com/file/d/1Isns3YH14E2vFaVFLvFmX4BAboak4IHN/view?usp=sharing"; // 프로그램 다운로드 파일 경로
  const appDownloadLink = "https://drive.google.com/file/d/1QD3CwheWpfx2lC4sYX2LKXo7i5sq6vHM/view?usp=drive_link"; // 앱 다운로드 파일 경로
  const manualDownloadLink = "LAVA_manual.pdf"; // 매뉴얼 다운로드 파일 경로
  const logoSrc = "/image.png"; // 로고 이미지 경로

  // 스타일 정의
  const lavaTextStyle = {
    fontFamily: "CustomFont, Arial, sans-serif", // 외부 폰트 적용
    fontSize: "24px",
    fontWeight: "bold",
    marginTop: "10px",
    color: "F23B3C", // 색상 변경
  };

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      {/* 상단 로고 */}
      <div style={{ marginBottom: "20px" }}>
        <img
          src={logoSrc}
          alt="Website Logo"
          style={{ maxWidth: "150px", height: "auto" }}
        />
        {/* 로고 아래 텍스트 */}
        <div style={lavaTextStyle}>LAVA</div>
      </div>

      <h1>Download Page</h1>
      <p>Select what you want to download:</p>

      {/* 프로그램 다운로드 버튼 */}
      <a
        href={programDownloadLink}
        download
        style={{
          display: "inline-block",
          marginTop: "20px",
          marginRight: "10px",
          padding: "10px 20px",
          backgroundColor: "#007BFF",
          color: "white",
          textDecoration: "none",
          borderRadius: "5px",
          fontSize: "16px",
        }}
      >
        Download Program
      </a>

      {/* 앱 다운로드 버튼 */}
      <a
        href={appDownloadLink}
        download
        style={{
          display: "inline-block",
          marginTop: "20px",
          marginLeft: "10px",
          marginRight: "10px",
          padding: "10px 20px",
          backgroundColor: "#28A745",
          color: "white",
          textDecoration: "none",
          borderRadius: "5px",
          fontSize: "16px",
        }}
      >
        Download App
      </a>

      {/* 매뉴얼 다운로드 버튼 */}
      <a
        href={manualDownloadLink}
        download
        style={{
          display: "inline-block",
          marginTop: "20px",
          marginLeft: "10px",
          padding: "10px 20px",
          backgroundColor: "#FFC107",
          color: "black",
          textDecoration: "none",
          borderRadius: "5px",
          fontSize: "16px",
        }}
      >
        Download Manual
      </a>
    </div>
  );
}

export default App;
